const SLUG_RE = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export function anchorIdForSlug(raw) {
  const s = (raw || '').toString().trim().toLowerCase();
  if (SLUG_RE.test(s)) return `schedule-${s}`;
  return '';
}
